import { Component } from '@angular/core';
import { Router, RouterModule, NavigationStart } from '@angular/router';
import { FormioModule, FormioAppConfig } from '@formio/angular';
import bootstrap5 from '@formio/bootstrap/bootstrap4';
import { HttpClientModule } from '@angular/common/http'; // For HttpClient service
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { LoadingComponent } from './loading/loading.component';
import { Formio } from '@formio/js';

Formio.use(bootstrap5);

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
    FormioModule,
    HttpClientModule,
    BreadcrumbComponent,
    LoadingComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
  providers: [{ provide: FormioAppConfig }],
})
export class AppComponent {
  title = 'intake-app';
  submissionData: any;
  loading: boolean = true;
  error: string | null = null;
  submissiondataSize: number = 0;
  constructor(private router: Router) {
    this.router.events.subscribe((s) => {
      if (s instanceof NavigationStart) {
        const params = new URLSearchParams(s.url.split('?')[1]);

        const tokenParam = params.get('token') || '';
        if (tokenParam !== undefined && tokenParam != '') {
          localStorage.setItem('formioToken', tokenParam);
        } else {
          const emailParam = params.get('email_address') || '';
          if (emailParam !== undefined && emailParam != '') {
            localStorage.setItem('email_address', emailParam);
          }
          const sfAcctIdParam = params.get('sf_account_id') || '';
          if (sfAcctIdParam !== undefined && sfAcctIdParam != '') {
            localStorage.setItem('sf_account_id', sfAcctIdParam);
          }

          const clinicCodeParam = params.get('clinic_code') || '';
          if (clinicCodeParam !== undefined && clinicCodeParam != '') {
            localStorage.setItem('clinic_code', clinicCodeParam);
          }
        }
      }
    });
  }

  ngOnInit() {}
}
